import { render, staticRenderFns } from "./ModifyBankInfo.vue?vue&type=template&id=b1ca480c&scoped=true"
import script from "./ModifyBankInfo.vue?vue&type=script&lang=js"
export * from "./ModifyBankInfo.vue?vue&type=script&lang=js"
import style0 from "./ModifyBankInfo.vue?vue&type=style&index=0&id=b1ca480c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ca480c",
  null
  
)

export default component.exports